<template>
  <AppDialog
    :model-value="modelValue"
    :title="title"
    :subtitle="subtitle"
    size="small"
    :loading="loading"
    :cancel-label="cancelLabel"
    :primary-label="confirmLabel"
    show-cancel
    show-primary
    :primary-color="variant === 'danger' ? 'danger' : variant === 'warning' ? 'warning' : 'primary'"
    @update:modelValue="onUpdateModelValue"
    @close="emit('cancel')"
    @primary="emit('confirm')"
  >
    <p class="app-dialog__message">{{ message }}</p>
    <p v-if="detail" class="app-dialog__detail">{{ detail }}</p>
    <div
      v-if="highlight"
      class="app-dialog__callout"
      :class="variant === 'warning' ? 'app-dialog__callout--warning' : 'app-dialog__callout--danger'"
    >
      <strong>{{ highlight }}</strong>
    </div>
    <slot />
  </AppDialog>
</template>

<script setup lang="ts">
import AppDialog from './AppDialog.vue'

withDefaults(
  defineProps<{
    modelValue: boolean
    title: string
    subtitle?: string
    message: string
    detail?: string
    highlight?: string
    variant?: 'danger' | 'warning' | 'info'
    confirmLabel?: string
    cancelLabel?: string
    loading?: boolean
  }>(),
  {
    subtitle: undefined,
    detail: undefined,
    highlight: undefined,
    variant: 'danger',
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
    loading: false,
  },
)

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
  cancel: []
}>()

function onUpdateModelValue(value: boolean) {
  emit('update:modelValue', value)
  if (!value) {
    emit('cancel')
  }
}
</script>
